import { useParams } from "react-router-dom"

export default function Home(){
    let {name} = useParams()
    let savedToken = localStorage.getItem("token")
    const username = localStorage.getItem("username");


    return(
        <div>
        <h1>Welcome to Fitness Tracker™!</h1>
        {
            username? <h3 className="loginMessage">You are signed in as: {username}!</h3> : <h3>You Are Not Signed In</h3>
        }
        </div>
    )
}